import React from "react"
import { Button, Result } from "antd"
import i18n from "../services/i18n"

interface IErrorBoundaryState {
  hasError: boolean
  error?: Error | null
}

// Deploy'dan keyin eski ochiq tabda lazy chunk fayli topilmay qolsa (yoki HTML
// qaytib kelsa) chiqadigan xatolarni aniqlaymiz — bular foydalanuvchi aybisiz,
// sahifani bir marta yangilash bilan to'liq hal bo'ladi.
function isChunkLoadError(error?: Error | null): boolean {
  if (!error) return false
  const msg = String(error.message || "")
  return (
    error.name === "ChunkLoadError" ||
    /Loading chunk [\d]+ failed|Loading CSS chunk|Unexpected token '<'|expected expression, got '<'/i.test(msg)
  )
}

// Render paytidagi kutilmagan xato butun ilovani "oq ekran" qilib qo'ymasligi uchun
// yagona himoya qatlami. Xato yuz berganda foydalanuvchiga tushunarli sahifa ko'rsatiladi.
// Chunk yuklash xatosida esa sahifa avtomatik bir marta yangilanadi (60s guard bilan,
// cheksiz reload siklidan himoya) — foydalanuvchi xato sahifasini umuman ko'rmaydi.
export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  IErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): IErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo)
    if (isChunkLoadError(error)) {
      try {
        const last = Number(sessionStorage.getItem("chunk_reload_at") || 0)
        if (Date.now() - last > 60000) {
          sessionStorage.setItem("chunk_reload_at", String(Date.now()))
          window.location.reload()
        }
      } catch {
        // sessionStorage ishlamasa ham xato sahifasi ko'rsatilaveradi
      }
    }
  }

  render() {
    if (this.state.hasError) {
      const errMsg = String(this.state.error?.message || "").slice(0, 300)
      return (
        <Result
          status="error"
          title={i18n.t("unexpectedError")}
          subTitle={i18n.t("errorBoundaryHint")}
          extra={[
            <Button
              type="primary"
              key="reload"
              onClick={() => window.location.reload()}
            >
              Обновить страницу
            </Button>,
            <Button
              key="home"
              onClick={() => {
                window.location.href = "/"
              }}
            >
              На главную
            </Button>,
          ]}
        >
          {errMsg ? (
            <div
              style={{
                textAlign: "center",
                color: "#94a3b8",
                fontSize: 12,
                wordBreak: "break-word",
              }}
            >
              {errMsg}
            </div>
          ) : null}
          <div className="test-mode-note" style={{ textAlign: "center", marginTop: 10 }}>⚠️ {i18n.t("testModeNotice")}</div>
        </Result>
      )
    }
    return this.props.children as React.ReactElement
  }
}
